webpackJsonp([14],{

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(830),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loaders_fullscreenLoader__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loaders_fullscreenLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loaders_fullscreenLoader__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//

//
/* harmony default export */ __webpack_exports__["default"] = ({
  //
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])([])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['loader'])),
  created: function created() {},
  mounted: function mounted() {
    this.$store.commit('uploadImage_1');
  },

  components: {
    loader: __WEBPACK_IMPORTED_MODULE_2__components_loaders_fullscreenLoader___default.a
    //
  } });

/***/ }),

/***/ 830:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Step 1/5")]), _vm._v(" "), (_vm.loader) ? _c('loader') : _c('a', {
    attrs: {
      "id": "upload"
    }
  }, [_vm._v("\n    Upload Profile Photo\n  ")]), _vm._v(" "), _c('img', {
    attrs: {
      "id": "photo"
    }
  })], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/v/1733832636781/js/14.0018a2201bc26ffd9334.js